import { VIEWS } from './consts';

export function getInitStep(props) {
  const { customizedInitStep, isCreationMethodEnabled } = props;
  if (customizedInitStep) {
    return customizedInitStep;
  } else if (isCreationMethodEnabled) {
    return VIEWS.CREATION_METHOD;
  }
  return VIEWS.GOALS;
}
